function s2ab (s: string) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}
export function getBlob (data: string, type: string): Blob {
  const decoded = s2ab(window.atob(data));
  const mimeType = mimeTypes.find(x => x.type == type);
  const blob = new Blob([decoded], { type: mimeType?.mime });
  return blob;
}

export default class mimeType {
  public type: string;
  public name: string;
  public mime: string;
}

export const mimeTypes: mimeType[] = [
  { type: 'xlsx', name: 'Fichier Excel (OpenXML)', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { type: 'json', name: 'Format JSON', mime: 'application/json' },
  { type: 'csv', name: 'Fichier CSV, séparateur point-virgule', mime: 'text/csv' },
  { type: 'png', name: 'Fichier PNG (Portable Network Graphics)', mime: 'image/png' },
  { type: 'pdf', name: 'Fichier PDF (Portable Document Format)', mime: 'application/pdf' },
  { type: 'txt', name: 'Fichier texte (ISO 8859-n)', mime: 'text/plain' },
  { type: 'xls', name: 'Fichier Excel', mime: 'application/vnd.ms-excel' },
];